module.exports = __webpack_public_path__ + "static/handphone-72e651248bdb860b52c10105ed06129a.png";